export const emailRegex = /^(([^<>()[\].,;:\s@"]+(.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;

export const emailStringToArray = (emailString) => emailString.split(',').map((email) => email.trim());

export const isEmailValid = (email) => emailRegex.test(email);
